module.exports = __webpack_public_path__ + "img/SER-B-2-II.59555d12.png";